import Text from '@amzn/meridian/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Feature, isFeatureEnabled } from '../../../../config/FeaturesConfig';
import {
  parseFixedString,
  PERCENTAGE_TABLE,
  TIME_TABLE,
  MetricBooleanMap,
  extractGeneralMetricValue,
} from './helper';
import { GeneralMetricType } from './types';

interface DisplayNetworkAvgVProp {
  metricType: string;
  metrics: GeneralMetricType;
  networkAvgMap: any;
}

const DisplayNetworkAvg: React.FC<DisplayNetworkAvgVProp> = ({
  metricType,
  metrics,
  networkAvgMap,
}: DisplayNetworkAvgVProp): React.ReactElement => {
  const networkAverage = extractGeneralMetricValue(metrics, true);

  const legacyExperience = !isFeatureEnabled(Feature.LIGHTHOUSE);

  if (
    networkAverage === null ||
    networkAvgMap === undefined ||
    legacyExperience
  )
    return <></>;

  const isTime = TIME_TABLE[metricType as keyof MetricBooleanMap];
  let networkAvgContent: string;
  if (isTime) {
    networkAvgContent = networkAverage! + ' ';
  } else {
    if (isNaN(parseFloat(networkAverage!))) {
      return <></>;
    }

    const valueFloat = parseFloat(networkAverage!);
    const isPercentage = PERCENTAGE_TABLE[metricType as keyof MetricBooleanMap];

    networkAvgContent = parseFixedString(valueFloat, isPercentage, false) + ' ';
  }

  return (
    <Text type='b200'>
      <b style={{ position: 'relative', top: '-3px' }}>
        {networkAvgContent}
        <FormattedMessage
          id={networkAvgMap.titleMessage.id}
          defaultMessage={networkAvgMap.titleMessage.defaultMessage}
        />
      </b>
    </Text>
  );
};

export default DisplayNetworkAvg;
